import { render, staticRenderFns } from "./historyScore.vue?vue&type=template&id=13321263"
import script from "./historyScore.vue?vue&type=script&lang=js"
export * from "./historyScore.vue?vue&type=script&lang=js"
import style0 from "./historyScore.vue?vue&type=style&index=0&id=13321263&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports